<h1 mat-dialog-title>External note for review</h1>

<div mat-dialog-content class="rnr">
    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>

    <div class="rnr__alert" *ngIf="loadError" data-test="load-error">
        <mat-icon>error_outline</mat-icon>
        <div>{{ loadError }}</div>
    </div>

    <ng-container *ngIf="note">
        <div class="rnr__meta">
            <span class="rnr__kind rnr__kind--{{ flagsTone(note) }}" data-test="kind">{{ flagsLabel(note) }}</span>
            <span>{{ patientLabel }}</span>
        </div>

        <div class="rnr__author" data-test="author">
            <mat-icon>badge</mat-icon>
            <div>
                <div class="rnr__author-name">{{ note.author.name }} {{ note.author.surname }} <span class="hint">(external)</span></div>
                <div class="hint">
                    {{ note.author.speciality }}
                    <span *ngIf="note.author.hpcsaNumber"> · HPCSA {{ note.author.hpcsaNumber }}</span>
                    <span *ngIf="note.author.practiceName"> · {{ note.author.practiceName }}</span>
                </div>
                <div class="hint">Note dated {{ note.noteDate | date: 'd MMM y' }} · written {{ note.submittedAt | date: 'd MMM y, HH:mm' }}</div>
            </div>
        </div>

        <div class="rnr__referral hint">
            Referred {{ note.referral.referredAt | date: 'd MMM y' }}: {{ note.referral.reason }}
        </div>

        <div class="rnr__note" data-test="note">
            <h3>{{ note.title }}</h3>
            <p>{{ note.notes }}</p>
        </div>

        <div class="rnr__files" *ngIf="note.attachments?.length" data-test="files">
            <h4>Files ({{ note.attachments.length }})</h4>
            <app-file-gallery *ngIf="galleryFiles.length" [fileObjects]="galleryFiles" [deleteEnabled]="false" [enableEditing]="false"></app-file-gallery>
            <div class="hint rnr__file-notice" *ngFor="let notice of fileNotices" data-test="file-notice">
                <mat-icon>{{ notice.blocking ? 'hourglass_top' : 'warning_amber' }}</mat-icon>
                <span><strong>{{ notice.name }}</strong>: {{ notice.text }}</span>
            </div>
            <button mat-stroked-button type="button" *ngIf="canRequestFilesAgain" (click)="requestFilesAgain()" [disabled]="isSaving" data-test="request-again">
                <mat-icon>refresh</mat-icon> Request the missing files again
            </button>
            <div class="hint" *ngIf="note.reviewStatus === 'pending' && galleryFiles.length">These files go to the patient's media with the note.</div>
        </div>

        <div class="rnr__status" *ngIf="note.reviewStatus !== 'pending'" data-test="already-reviewed">
            <mat-icon>{{ note.reviewStatus === 'validated' ? 'check_circle' : 'block' }}</mat-icon>
            <div>
                {{ note.reviewStatus === 'validated' ? 'Validated to the timeline' : 'Dismissed' }}
                <span *ngIf="note.reviewedByName"> by {{ note.reviewedByName }}</span>
                <span *ngIf="note.reviewedAt"> on {{ note.reviewedAt | date: 'd MMM y' }}</span>
                <div *ngIf="note.dismissReason" class="hint">Reason: {{ note.dismissReason }}</div>
            </div>
        </div>

        <ng-container *ngIf="note.canReview">
            <div class="rnr__warning" *ngIf="warning" data-test="warning">
                <mat-icon>warning_amber</mat-icon>
                <div>{{ warning }}</div>
            </div>

            <p class="hint">Adding it puts this note on the patient's timeline as a read-only note, attributed to its
                author. Dismissing keeps it out of the record. The author is not told either way.</p>

            <mat-form-field appearance="outline" class="full-width" *ngIf="dismissing">
                <mat-label>Why is this note being dismissed?</mat-label>
                <textarea matInput [(ngModel)]="dismissReason" [maxlength]="dismissMax" rows="3" cdkTextareaAutosize
                    placeholder="For example: wrong patient, duplicate, not clinically relevant" data-test="dismiss-reason"></textarea>
            </mat-form-field>
        </ng-container>

        <p class="hint" *ngIf="!note.canReview && note.reviewStatus === 'pending'" data-test="cannot-review">
            Only administrators and physicians can validate or dismiss external notes.
        </p>

        <div class="rnr__alert" *ngIf="actionError" data-test="action-error">
            <mat-icon>error_outline</mat-icon>
            <div>{{ actionError }}</div>
        </div>
    </ng-container>
</div>

<div mat-dialog-actions align="end">
    <button mat-button (click)="close()" [disabled]="isSaving">Close</button>
    <ng-container *ngIf="note?.canReview">
        <ng-container *ngIf="!dismissing">
            <button mat-stroked-button color="warn" (click)="dismissing = true" [disabled]="isSaving" data-test="dismiss">Dismiss…</button>
            <button mat-flat-button color="primary" (click)="validate()" [disabled]="isSaving || filesPending" data-test="validate"
                [matTooltip]="filesPending ? 'Waiting for the note\'s files to arrive' : ''">
                {{ isSaving ? 'Saving…' : 'Add to timeline' }}
            </button>
        </ng-container>
        <ng-container *ngIf="dismissing">
            <button mat-button (click)="dismissing = false; actionError = null" [disabled]="isSaving">Back</button>
            <button mat-flat-button color="warn" (click)="confirmDismiss()" [disabled]="isSaving || !dismissReason.trim()" data-test="confirm-dismiss">
                {{ isSaving ? 'Saving…' : 'Dismiss note' }}
            </button>
        </ng-container>
    </ng-container>
</div>
